import { callRestPost, callRestGet } from "../../../utils/callRestApi";

export const fundamentalApi = {
  createNew: async (body) => {
    const result = { data: null, error: null };
    await callRestPost("dashboard/analytics/fundamental", body, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 200) {
          result.data = res.data;
        } else {
          result.error = res;
        }
      })
      .catch((err) => {
        if (err.message === "Request failed with status code 401") {
          localStorage.setItem("accessToken", "");
          window.location.href = "/login";
        }
        result.error = err;
      });

    return result;
  },
  single: async (uuid) => {
    const result = { data: null, error: null };
    await callRestGet(`/dashboard/analytics/fundamental/${uuid}`, null)
      .then((res) => {
        if (res.status === 200) {
          result.data = res.data;
        } else {
          result.error = res;
        }
      })
      .catch((err) => {
        if (err.message === "Request failed with status code 401") {
          localStorage.setItem("accessToken", "");
          window.location.href = "/login";
        }
        result.error = err;
      });

    return result;
  },
};
